import ReportView, { type ReportColumn, type ReportOption } from '../../../components/reports/ReportView';

const STATUS_OPTIONS: ReportOption[] = [
  { value: 'pending', label: 'Pending' },
  { value: 'included', label: 'Included' },
  { value: 'returned', label: 'Returned' },
  { value: 'voided', label: 'Voided' },
];

const COLUMNS: ReportColumn[] = [
  { key: 'batch_number', label: 'Batch' },
  { key: 'batch_status', label: 'Batch Status' },
  { key: 'reference', label: 'Claim Reference' },
  { key: 'member_name', label: 'Member' },
  { key: 'bank_name', label: 'Bank' },
  { key: 'amount', label: 'Amount', align: 'right', type: 'money' },
  { key: 'status', label: 'Line Status' },
];

export function PaymentBatchesReport() {
  return (
    <ReportView
      title="Benefit Payment Batches Register"
      description="Every EFT batch line generated for a benefit claim, with bank details and disbursement status."
      endpoint="/reports/benefits/payment-batches"
      columns={COLUMNS}
      filters={['status', 'dateRange']}
      statusOptions={STATUS_OPTIONS}
    />
  );
}
